// iter v28 r470 — Cornice iPhone 17 Pro riutilizzabile per landing + social kit.
// Caratteristiche moderne iPhone 17 Pro:
//   • Bordi titanium ultra-sottili (2px frame, 1px screen offset)
//   • Angoli più arrotondati (rounded-[44px] external, rounded-[40px] screen)
//   • Dynamic Island grande orizzontale ovale (ratio 3.5:1)
//   • Gradient titanium leggero su frame esterno
//   • Specular highlight sottile sul vetro
//   • Ombra più profonda e diffusa
//
// API:
//   <IPhone17ProFrame size="md" tone="titanium">
//     {/* contenuto schermo */}
//   </IPhone17ProFrame>
//
// size: "xs" (180px) · "sm" (220px) · "md" (300px) · "lg" (400px) · "full" (riempie genitore)
// tone: "titanium" (default · default Pro) · "graphite" · "natural" · "desert"

import React from "react";

const SIZE_MAP = {
  xs: { width: 180, radius: 32, screenRadius: 30, islandW: 56, islandH: 14, islandTop: 8 },
  sm: { width: 220, radius: 36, screenRadius: 34, islandW: 70, islandH: 18, islandTop: 10 },
  md: { width: 300, radius: 44, screenRadius: 40, islandW: 96, islandH: 26, islandTop: 14 },
  lg: { width: 400, radius: 56, screenRadius: 50, islandW: 124, islandH: 34, islandTop: 18 },
  full: { width: null, radius: 60, screenRadius: 54, islandW: 130, islandH: 36, islandTop: 18 },
};

const TONE_MAP = {
  titanium: {
    bg: "linear-gradient(135deg, #2A2A28 0%, #1C1C1A 50%, #2F2F2D 100%)",
    accent: "#3A3A38",
  },
  graphite: {
    bg: "linear-gradient(135deg, #1F1F1D 0%, #0F0F0E 50%, #1F1F1D 100%)",
    accent: "#2A2A28",
  },
  natural: {
    bg: "linear-gradient(135deg, #B8B0A0 0%, #8E867A 50%, #A89F8E 100%)",
    accent: "#9A968B",
  },
  desert: {
    bg: "linear-gradient(135deg, #C8A87E 0%, #A88560 50%, #C8A87E 100%)",
    accent: "#9A7D5C",
  },
};

export default function IPhone17ProFrame({
  size = "md",
  tone = "titanium",
  children,
  className = "",
  testId = "iphone-17-pro",
  shadow = true,
  showIsland = true,
}) {
  const dim = SIZE_MAP[size] || SIZE_MAP.md;
  const ton = TONE_MAP[tone] || TONE_MAP.titanium;
  const wrapStyle = dim.width
    ? { width: dim.width, aspectRatio: "9 / 19.5" }
    : { width: "100%", height: "100%" };

  return (
    <div
      data-testid={testId}
      className={"relative " + className}
      style={{
        ...wrapStyle,
        background: ton.bg,
        borderRadius: dim.radius,
        padding: 3,
        boxShadow: shadow
          ? "0 32px 64px -20px rgba(28,28,26,0.45), 0 8px 16px -8px rgba(28,28,26,0.25), inset 0 1px 0 rgba(255,255,255,0.06)"
          : "none",
      }}
    >
      {/* Inner titanium ring */}
      <div
        style={{
          position: "absolute",
          inset: 1,
          borderRadius: dim.radius - 1,
          background: `linear-gradient(135deg, ${ton.accent}, transparent 60%, ${ton.accent})`,
          pointerEvents: "none",
          opacity: 0.5,
        }}
      />
      {/* Screen */}
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "100%",
          background: "#FAFAF7",
          borderRadius: dim.screenRadius,
          overflow: "hidden",
        }}
      >
        {/* Dynamic Island grande orizzontale */}
        {showIsland && (
          <div
            style={{
              position: "absolute",
              top: dim.islandTop,
              left: "50%",
              transform: "translateX(-50%)",
              width: dim.islandW,
              height: dim.islandH,
              background: "#000000",
              borderRadius: 999,
              zIndex: 10,
              boxShadow: "0 1px 2px rgba(0,0,0,0.3)",
            }}
          />
        )}
        {/* Specular highlight sottile (luce sul vetro) */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            height: "30%",
            background: "linear-gradient(180deg, rgba(255,255,255,0.04), transparent)",
            pointerEvents: "none",
            zIndex: 5,
          }}
        />
        {children}
      </div>
    </div>
  );
}
